import { createContext, useContext } from "react";
import { type ProfileView } from "shared/mappers/database/profile/profile";

export interface ProfileContextType extends ProfileView {
  refreshProfile: () => Promise<void>;
  isLoading: boolean;
  isFetching: boolean;
}

const ProfileContext = createContext<ProfileContextType | null>(null);

const useProfileContext = (): ProfileContextType => {
  const profile = useContext(ProfileContext);
  if (profile === undefined) {
    throw new Error("useProfileContext must be used within a ProfileContext");
  }
  if (profile === null) {
    throw new Error("ProfileContext is null");
  }
  return profile;
};

export { ProfileContext, useProfileContext };
